import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from 'react-leaflet';

// Auto-fit the map to show all markers with padding
function FitBounds({ points }) {
  const map = useMap();

  if (points.length > 0) {
    const bounds = L.latLngBounds(points);
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
  }

  return null;
}

function Map({
  coordinatesData,
  markerDepartureToggle,
  markerDestinationToggle,
  readOnly = false,
}) {
  const { pickUpLat, pickUpLong, dropOffLat, dropOffLong } = coordinatesData;
  const key = JSON.stringify(coordinatesData);

  // Collect valid marker points for bounds fitting
  const points = [];
  if (markerDepartureToggle && pickUpLat && pickUpLong) {
    points.push([pickUpLat, pickUpLong]);
  }
  if (markerDestinationToggle && dropOffLat && dropOffLong) {
    points.push([dropOffLat, dropOffLong]);
  }

  // Default center: Bellingham area
  const defaultCenter = [48.75, -122.45];
  const center = points.length > 0 ? points[0] : defaultCenter;

  return (
    <MapContainer
      key={key}
      className="map"
      center={center}
      zoom={12}
      scrollWheelZoom={!readOnly}
      dragging={!readOnly}
      zoomControl={!readOnly}
      doubleClickZoom={!readOnly}
      touchZoom={!readOnly}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <FitBounds points={points} />
      {markerDepartureToggle && pickUpLat && pickUpLong && (
        <CircleMarker
          center={[pickUpLat, pickUpLong]}
          radius={10}
          pathOptions={{
            color: '#16a34a',
            fillColor: '#22c55e',
            fillOpacity: 0.8,
            weight: 2,
          }}
        >
          <Popup>Pick Up</Popup>
        </CircleMarker>
      )}
      {markerDestinationToggle && dropOffLat && dropOffLong && (
        <CircleMarker
          center={[dropOffLat, dropOffLong]}
          radius={10}
          pathOptions={{
            color: '#dc2626',
            fillColor: '#ef4444',
            fillOpacity: 0.8,
            weight: 2,
          }}
        >
          <Popup>Drop Off</Popup>
        </CircleMarker>
      )}
    </MapContainer>
  );
}

export default Map;
